<template>
  <ModalSlotted @close="$emit('closed')">
    <header slot="header">
      <h1>Alterar senha para {{user.name}}</h1>
    </header>
    <div slot="body">
      <form @submit.prevent="submit()" class="flex flex-col px-8 pt-8 pb-4" >
        <InputPassword @changed="form.password = $event" />
      </form>
    </div>
    <footer slot="footer">
      <button @click="$emit('closed')" class="ml-auto btn">Cancelar</button>
      <button :disabled="!form.password || saving" @click="submit()" class="ml-2 btn btn--primary">Salvar</button>
    </footer>
  </ModalSlotted>
</template>

<script lang="ts">
import axios from 'axios'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'ModalPassword',
  props: {
    user: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState('auth', ['userProfile'])
  },
  data () {
    return {
      form: {
        password: null
      },
      saving: false
    }
  },
  methods: {
    ...mapMutations('global', ['SET_IS_LOADING']),
    submit () {
      const request = {
        url: `${process.env.VUE_APP_NEW_API}/user/${this.user.id}/changePassword`,
        data: this.form,
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + this.userProfile.token
        }
      }
      this.SET_IS_LOADING(true)
      this.saving = true
      axios(request).then(
        () => {
          this.$emit('closed')
        }
      ).catch(
        (err) => {
          console.log(err)
          alert('Erro')
        }
      ).finally(
        () => {
          this.SET_IS_LOADING(false)
          this.saving = false
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
form {
  >div {
    @apply mb-4 w-full h-8 flex items-center;
    strong {
      @apply w-32 inline-block text-right mr-2;
    }
  }
  input[type=email], input[type=text], input[type=password] {
    @apply border border-gray-100 border-solid p-2 w-auto;
  }
}
</style>
